<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <ul class="footer-list">
        <li>
          <a>{{ $t('Footer_1') }}</a>
        </li>
        <li>
          <router-link :to="{ name: 'QATop' }">{{ $t('Footer_2') }}</router-link>
        </li>
        <li>
          <a>{{ $t('Footer_3') }}</a>
        </li>
        <li>
          <a>{{ $t('Footer_4') }}</a>
        </li>
        <li>
          <a>{{ $t('Footer_5') }}</a>
        </li>
      </ul>
      <p>{{ $t('Footer_6') }}</p>
    </div>
  </footer>
</template>

<style lang="scss">
footer {
  a {
    color: #4a4a4a;

    &:hover {
      color: #aaa;
    }
  }
}

.footer {
  li {
    display: inline-block;
    margin: 0 0.5rem;
  }

  p {
    font-size: 0.9rem;
  }
}
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {};
  }
};
</script>
